import { useEffect } from 'react';

import Input from '@cartwhl/ui/atoms/Input';
import CircleCrossIcon from '@cartwhl/ui/icons/CircleCrossIcon';
import SearchIcon from '@cartwhl/ui/icons/SearchIcon';
import Button from '@cartwhl/ui/input/Button';

// TODO: move to UI library --> layout component, should be a part of the panel
export default function PanelSearch({
  isSearchBarActive,
  setSearchBarActive,
  searchTerm,
  setSearchTerm,
}: {
  isSearchBarActive: boolean;
  setSearchBarActive: (v: boolean) => void;
  searchTerm: string;
  setSearchTerm: (v: string) => void;
}) {
  // ensure that if the serach is cleared after the history term is cleared
  useEffect(() => {
    return () => {
      setSearchBarActive(false);
      setSearchTerm('');
    };
  }, [setSearchBarActive, setSearchTerm]);
  return (
    <>
      <Button
        variant="tertiary"
        icon={<SearchIcon />}
        onClick={() => setSearchBarActive(true)}
        className={`lg:-mr-2.5 ${isSearchBarActive ? 'hidden' : ''}`}
      />
      <div
        className={`dark:bg-gray-90 absolute left-0 right-9 origin-right bg-white transition-all lg:right-0 ${
          isSearchBarActive
            ? 'pointer-events-auto translate-x-0 scale-x-100 opacity-100'
            : 'pointer-events-none translate-x-10 scale-x-0 opacity-0'
        }`}
      >
        <SearchIcon className="absolute left-1.5 top-1.5 h-7 w-7" />
        <Input
          id="panel-search-input"
          placeholder="Search history"
          name="panel-search"
          className="pl-9 pr-9"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          onClick={() => {
            setSearchTerm('');
            setSearchBarActive(false);
          }}
          className=" text-gray-45 hover:text-gray-75 absolute right-1 top-1.5 transition-colors dark:hover:text-white"
        >
          <CircleCrossIcon className="h-7 w-7" />
        </button>
      </div>
    </>
  );
}
